import {Col, Form, Row} from "react-bootstrap";
import classes from "./FormField.module.css"
import React from "react";
import SpellChecker from "../SpellChecker/SpellChecker";

let Element = (props) => {

    return (
        <Form.Group as={ Row }>
            <Form.Label column sm={ props.colsSizing ? props.colsSizing.l : 3 }> { props.label }{ props.isRequired &&
            <span className={ classes.requiredField }>*</span> } </Form.Label>
            <Col sm={ props.colsSizing ? props.colsSizing.c : 9 }>
                { ((props.type === "input" || !props.type) && (props.as === "input" || !props.as)) ?
                    <SpellChecker
                        value={ props.value }
                        onChange={ props.onChange }
                        isDisabled={ props.disabled }
                        isInvalid={ props.isInvalid }
                        controlFeedback={ props.feedback }
                        dict={ props.dict }
                        lang={ props.lang }
                        notify={ props.notify }
                        feedback={ props.feedback }
                        addToDictionary={ props.addToDictionary }
                    />
                    :
                    <Form.Control
                        type={ props.type ? props.type : "input" }
                        as={ props.as ? props.as : "input" }
                        value={ props.value }
                        onChange={ (e) => {
                            props.onChange (e.target.value)
                        } }
                        disabled={ props.disabled }
                        isInvalid={ props.isInvalid }>
                        { props.children }
                    </Form.Control>
                }

                <Form.Control.Feedback type="invalid"> { props.feedback } </Form.Control.Feedback>
            </Col>
            <Col>{ props.extraCol }</Col>
        </Form.Group>
    )
}

export default Element;